export enum BookingStatusCellClasses {
  ROSE = 'rose',
  GREEN = 'green',
  PURPLE = 'purple',
  DARK = 'dark',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  BLUE = 'blue',
}
